export default {
  getSidebar: function() {
    let meanu = [
      {
        name: "我的课程",
        children: [
          {
            name: "我发布的课程",
            icon: "icon iconfont icon-fabu",
            path: "/mycoursegoods"
          },
          {
            name: "课程审批管理",
            icon: "icon iconfont icon-shengpi",
            path: "/Courseapproval"
          },
          {
            name: "课程学习统计",
            icon: "icon iconfont icon-goumaijilu",
            path: "/Coursesales/study"
          },
          // {
          //   name: "课程购买订单",
          //   icon: "icon iconfont icon-goumaijilu",
          //   path: "Coursepurchase"
          // },
          {
            name: "课程点评管理",
            icon: "icon iconfont icon-pingjia",
            path: "/evaluate"
          },
          {
            name: "课程提问管理",
            icon: "icon iconfont icon-shoucang",
            path: "/askQuestion"
          },
          {
            name: "课程笔记管理",
            icon: "icon iconfont icon-shoucang",
            path: "/note"
          }
        ],
        path: "/course",
        icon: "icon iconfont icon-kecheng"
      },
      {
        name: "知识库管理",
        children: [
          {
            name: "知识库管理",
            icon: "icon iconfont icon-fabu",
            path: "/myknowledge"
          },
          {
            name: "微信消息通知",
            icon: "icon iconfont icon-tongzhi",
            path: "/message"
          }
        ],
        path: "/course",
        icon: "icon iconfont icon-kecheng"
      },
      {
        name: "会议签到",
        children: [
          {
            name: "会议签到管理",
            icon: "icon iconfont icon-fabu",
            path: "/signMeeting"
          }
        ],
        path: "/course",
        icon: "icon iconfont icon-kecheng"
      },
      {
        name: "访问管理",
        children: [
          {
            name: "访问审核",
            icon: "icon iconfont icon-zhishi",
            path: "/visit"
          },
          {
            name: "访客记录",
            icon: "icon iconfont icon-zhishi",
            path: "/visitdetail"
          }
        ],
        path: "/course",
        icon: "icon iconfont icon-kecheng"
      },
      {
        name: "题库管理",
        path: "/Questionbank",
        children: [
          {
            name: "科目大纲",
            icon: "icon iconfont icon-kaoshi",
            path: "/examinationsyllabus"
          },
          {
            name: "我的题库",
            icon: "icon iconfont icon-tiku",
            path: "/myQuestionbank"
          }
        ],
        icon: "icon iconfont icon-tiku"
      },
      {
        name: "考试管理",
        path: "/kaoshi",
        children: [
          {
            name: "我的试卷",
            icon: "icon iconfont icon-shijuan",
            path: "/mytestpaper"
          },
          {
            name: "创建考试",
            icon: "icon iconfont icon-chuangjian",
            path: "/creat"
          },
          {
            name: "考试管理",
            icon: "icon iconfont icon-kaoshiguanli",
            path: "/examination"
          },
          {
            name: "我的监考",
            icon: "icon iconfont icon-zhujiangren",
            path: "/myInvigilator"
          }
          // {
          //   name: "阅卷管理",
          //   icon: "icon iconfont icon-yuejuan",
          //   path: "/Markingmanagement"
          // }
        ],
        icon: "icon iconfont icon-kaoshiguanli"
      },
      {
        name: "员工学习管理",
        path: "/jiaoxue",
        children: [
          {
            name: "学习计划管理",
            icon: "icon iconfont icon-xuexijihua-1",
            path: "/studyplan"
          },
          // {
          //   name: "我设计的课程",
          //   icon: "icon iconfont icon-sheji",
          //   path: "design"
          // },
          // {
          //   name: "我主讲的课程",
          //   icon: "icon iconfont icon-zhujiangren",
          //   path: "speaker"
          // },
          // {
          //   name: "我助讲的课程",
          //   icon: "icon iconfont icon-xueshengguanli",
          //   path: "Markingmanagements"
          // },
          {
            name: "作业和测验",
            icon: "icon iconfont icon-zuoye",
            path: "/task"
          },
          // {
          //   name: "课程提问管理",
          //   icon: "icon iconfont icon-tiwen",
          //   path: "Questionmanagement"
          // },
          // {
          //   name: "课程统分管理",
          //   icon: "icon iconfont icon-tongji",
          //   path: "Statistics"
          // },
          {
            name: "课程证书管理",
            icon: "icon iconfont icon-tiku",
            path: "/certificate"
          }
        ],
        icon: "icon iconfont icon-jiaoxue"
      },
      {
        name: "辅助学习管理",
        path: "/fuzhu",
        children: [
          // {
          //   name: "圈子管理",
          //   icon: "icon iconfont icon-quanziguanli",
          //   path: "/circle"
          // },
          // {
          //   name: "举报管理",
          //   icon: "icon iconfont icon-chakantiezigengduojubao",
          //   path: "/report"
          // },
          {
            name: "标签管理",
            icon: "icon iconfont icon-wenjuantiaocha",
            path: "/studentTag"
          },
          {
            name: "问卷调查",
            icon: "icon iconfont icon-wenjuantiaocha",
            path: "/questionnaireinvestigation"
          },
          {
            name: "学员管理",
            icon: "icon iconfont icon-xueshengguanli",
            path: "/students"
          }
        ],
        icon: "icon iconfont icon-fuzhuguanli"
      },
      {
        name: "系统报表",
        path: "/baobiao",
        children: [
          {
            name: "系统看板",
            icon: "icon iconfont icon-kaoshi",
            path: "/Examinationreport"
          },
          // {
          //   name: "课程看板",
          //   icon: "icon iconfont icon-kecheng",
          //   path: "coursereport"
          // },
          // {
          //   name: "题库报表",
          //   icon: "icon iconfont icon-tiku",
          //   path: "Questionbankreport"
          // },
          {
            name: "考试看板",
            icon: "icon iconfont icon-zuoye",
            path: "/testreport"
          }
        ],
        icon: "icon iconfont icon-tiku"
      },
      {
        name: "系统配置",
        path: "/wuzhihua",
        children: [
          {
            name: "机构管理",
            icon: "icon iconfont icon-jigouguanli",
            path: "/organization"
          },
          {
            name: "分类管理",
            icon: "icon iconfont icon-kaoshiguanli",
            path: "/coursetype"
          },
          {
            name: "系统占位符",
            icon: "icon iconfont icon-text__easyiconnet",
            path: "/slideshow"
          },
          {
            name: "用户管理",
            icon: "icon iconfont icon-RectangleCopy1",
            path: "/userquery"
          },
          {
            name: "角色权限",
            icon: "icon iconfont icon-quanxian",
            path: "/role"
          },
          // {
          //   name: "告警管理",
          //   icon: "icon iconfont icon-kaoshiguanli",
          //   path: "/alarm"
          // },
          {
            name: "通知管理",
            icon: "icon iconfont icon-tongzhi",
            path: "/notify"
          },
          {
            name: "故障处理手册",
            icon: "icon iconfont icon-guzhang1",
            path: "/faultHandling"
          },
          {
            name: "系统日志",
            icon: "icon iconfont icon-huaban43",
            path: "/loginLog"
          }
        ],
        icon: "icon iconfont icon-daojishi"
      }
    ];
    return meanu;
  },

  getmycoursegoods: function() {
    let list = [
      {
        courseGoodsId: "158",
        courseGoodsName: "酒店企业文化课程",
        courseDesc: "酒店企业文化课程",
        courseStatus: "1",
        dod: "简单",
        isfree: "0",
        assistStatus: "null",
        salesStatus: "null",
        lessionnum: "1",
        courseImage: "null",
        timelong: "null",
        courseType: "0",
        isopen: "0",
        starLevel: "null",
        studycount: "null",
        addtime: "2021-07-06 00:00:00",
        Courseclassification: "企业文化"
      },
      {
        courseGoodsId: "143",
        courseGoodsName: "住宿管理课程",
        courseDesc: "字幕测试课程字幕测试课程",
        courseStatus: "0",
        dod: "简单",
        isfree: "1",
        assistStatus: "null",
        salesStatus: "null",
        lessionnum: "1",
        courseImage: "null",
        timelong: "null",
        courseType: "0",
        isopen: "1",
        starLevel: "null",
        studycount: "null",
        addtime: "2021-07-17 00:00:00",
        Courseclassification: "企业文化",
        details: "",
        knows: "",
        outline: ""
      },
      {
        courseGoodsId: "141",
        courseGoodsName: "餐饮规范管理课程",
        courseDesc:
          "路桥员工培训课程路桥员工培训课程路桥员工培训课程路桥员工培训课程",
        courseStatus: "4",
        dod: "简单",
        isfree: "0",
        assistStatus: "0",
        salesStatus: "null",
        lessionnum: "0",
        courseImage: "null",
        timelong: "null",
        courseType: "2",
        isopen: "1",
        starLevel: "null",
        studycount: "null",
        addtime: "2021-07-19 00:00:00",
        Courseclassification: "企业文化",
        details: "",
        knows: "",
        outline: ""
      },
      {
        courseGoodsId: "139",
        courseGoodsName: "娱乐规范管理课程",
        courseDesc: "php老师发布的导学课程",
        courseStatus: "4",
        dod: "简单",
        isfree: "0",
        assistStatus: "1",
        salesStatus: "null",
        lessionnum: "1",
        courseImage: "null",
        timelong: "null",
        courseType: "2",
        isopen: "1",
        starLevel: "null",
        studycount: "null",
        addtime: "2021-07-23 00:00:00",
        Courseclassification: "企业文化",
        details: "",
        knows: "",
        outline: ""
      },
      {
        courseGoodsId: "137",
        courseGoodsName: "酒店网管管理课程",
        courseDesc: "php老师发布的公开课",
        courseStatus: "4",
        dod: "简单",
        isfree: "0",
        assistStatus: "1",
        salesStatus: "1",
        lessionnum: "1",
        courseImage: "null",
        timelong: "null",
        courseType: "0",
        isopen: "1",
        starLevel: "null",
        studycount: "null",
        addtime: "2021-07-23 00:00:00",
        Courseclassification: "企业文化",
        details: "",
        knows: "",
        outline: ""
      }
    ];
    return list;
  },
  getmycoursegoodszjgl: function() {
    let list = [
      {
        courseGoodsId: "158",
        courseGoodsName: "1.0",
        courseDesc: "酒店企业文化课程",
        courseStatus: "酒店企业文化课程",
        dod: "简单",
        isfree: "0",
        assistStatus: "null",
        salesStatus: "null",
        lessionnum: "服务理念",
        courseImage: "null",
        timelong: "null",
        courseType: "0",
        isopen: "0",
        starLevel: "null",
        studycount: "",
        addtime: "",
        children: []
      },
      {
        courseGoodsId: "143",
        courseGoodsName: "2.0",
        courseDesc: "字幕测试课程字幕测试课程",
        courseStatus: "酒店企业文化课程",
        dod: "简单",
        isfree: "1",
        assistStatus: "null",
        salesStatus: "null",
        lessionnum: "经营理念",
        courseImage: "null",
        timelong: "null",
        courseType: "酒店企业文化课程",
        isopen: "1",
        starLevel: "null",
        studycount: "",
        addtime: "",
        children: []
      },
      {
        courseGoodsId: "141",
        courseGoodsName: "3.0",
        courseDesc:
          "路桥员工培训课程路桥员工培训课程路桥员工培训课程路桥员工培训课程",
        courseStatus: "酒店企业文化课程",
        dod: "简单",
        isfree: "0",
        assistStatus: "酒店企业文化课程",
        salesStatus: "null",
        lessionnum: "企业",
        courseImage: "null",
        timelong: "null",
        courseType: "2",
        isopen: "1",
        starLevel: "null",
        studycount: "",
        addtime: "",
        children: [
          {
            courseGoodsId: "139",
            courseGoodsName: "3.1",
            courseDesc: "php老师发布的导学课程",
            courseStatus: "酒店企业文化课程",
            dod: "简单",
            isfree: "0",
            assistStatus: "1",
            salesStatus: "null",
            lessionnum: "企业精神",
            courseImage: "null",
            timelong: "null",
            courseType: "2",
            isopen: "1",
            starLevel: "null",
            studycount: "已添加",
            addtime: "视频"
          },
          {
            courseGoodsId: "137",
            courseGoodsName: "3.2",
            courseDesc: "php老师发布的公开课",
            courseStatus: "酒店企业文化课程",
            dod: "简单",
            isfree: "0",
            assistStatus: "1",
            salesStatus: "1",
            lessionnum: "企业宗旨",
            courseImage: "null",
            timelong: "null",
            courseType: "0",
            isopen: "1",
            starLevel: "null",
            studycount: "已添加",
            addtime: "视频"
          }
        ]
      }
    ];
    return list;
  },
  getCoursesales: function() {
    let list = [
      {
        orderId: "3245",
        orderState: "1",
        count: "1",
        orderMoney: "3",
        orderName: "酒店企业文化课程",
        id: "张三"
      },
      {
        orderId: "3244",
        orderState: "0",
        count: "1",
        orderMoney: "3",
        orderName: "酒店网管管理课程",
        id: "张三"
      },
      {
        orderId: "3241",
        orderState: "0",
        count: "1",
        orderMoney: "3",
        orderName: "住宿管理课程",
        id: "张三"
      },
      {
        orderId: "3164",
        orderState: "1",
        count: "1",
        orderMoney: "3",
        orderName: "餐饮规范管理课程",
        id: "李四"
      },
      {
        orderId: "3161",
        orderState: "0",
        count: "1",
        orderMoney: "12",
        orderName: "课程复习与总结",
        id: "李四"
      }
    ];
    return list;
  },
  getCoursepurchase: function() {
    let list = [
      {
        orderId: "3242",
        orderState: "1",
        count: "5",
        orderMoney: "5",
        orderName: "PHP面向对象编程",
        id: "1000001387846303"
      },
      {
        orderId: "3241",
        orderState: "0",
        count: "1",
        orderMoney: "3",
        orderName: "php老师发布的公开课",
        id: "1000001938653150"
      },
      {
        orderId: "2979",
        orderState: "1",
        count: "4",
        orderMoney: "4",
        orderName: "微信小程序开发",
        id: "1000001708060750"
      },
      {
        orderId: "2840",
        orderState: "1",
        count: "1",
        orderMoney: "100",
        orderName: "计算机语言概要",
        id: "1000001912095322"
      },
      {
        orderId: "2620",
        orderState: "1",
        count: "1",
        orderMoney: "0",
        orderName: "字幕测试课程",
        id: "1000001922452323"
      },
      {
        orderId: "2619",
        orderState: "0",
        count: "1",
        orderMoney: "0",
        orderName: "字幕测试课程",
        id: "1000000669678905"
      },
      {
        orderId: "1716",
        orderState: "1",
        count: "1",
        orderMoney: "3",
        orderName: "php老师发布的公开课",
        id: "1000000312043691"
      },
      {
        orderId: "1662",
        orderState: "1",
        count: "3",
        orderMoney: "9",
        orderName: "mybatis入门到精通（经典版本）",
        id: "1000000135067037"
      },
      {
        orderId: "1661",
        orderState: "0",
        count: "1",
        orderMoney: "3",
        orderName: "mybatis入门到精通（经典版本）",
        id: "1000001531433651"
      },
      {
        orderId: "1660",
        orderState: "1",
        count: "1",
        orderMoney: "3",
        orderName: "mybatis入门到精通（经典版本）",
        id: "1000000328034775"
      }
    ];
    return list;
  },
  getevaluate: function() {
    let list = [
      {
        courseReviewId: "643",
        review: "能够学习到丰富的企业管理知识",
        createtime: "2021-05-05 10:56:36",
        formatStarLevel: "非常好",
        lessionnum: "1",
        formatTimelong: "0时6分18秒",
        truename: "Cxy123",
        courseGoodsName: "酒店企业文化课程",
        courseReviewStatus: "0",
        studycount: "0"
      },
      {
        courseReviewId: "642",
        review: "还不错还不错",
        createtime: "2021-05-05 10:56:03",
        formatStarLevel: "非常好",
        lessionnum: "1",
        formatTimelong: "0时6分18秒",
        truename: "Cxy123",
        courseGoodsName: "住宿管理课程",
        courseReviewStatus: "1",
        studycount: "0"
      },
      {
        courseReviewId: "422",
        review: "这个课程还不错  现在离不开培训平台服务了",
        createtime: "2019-09-27 17:59:59",
        formatStarLevel: "非常好",
        lessionnum: "4",
        formatTimelong: "2时3分21秒",
        truename: "Cxy123",
        courseGoodsName: "酒店网管管理课程",
        courseReviewStatus: "1",
        studycount: "0"
      }
    ];
    return list;
  },
  getCollection: function() {
    let list = [
      {
        favoritesId: "63",
        courseGoodsName: "php老师发布的公开课",
        courseGoodsId: "137",
        courseImage: "upload/20181123/twuvz/xtvuz1542947586343.jpg",
        isfree: "0",
        username: "zxstudent1",
        companyName: "中山大学",
        deptName: "研发一部",
        courseType: "1",
        userId: "10992",
        addTime: "2021-06-11 14:37:21"
      },
      {
        favoritesId: "61",
        courseGoodsName: "课程复习与总结",
        courseGoodsId: "158",
        courseImage: "upload/20211106/rsxtu/wuuzw1604596829184.jpg",
        isfree: "0",
        username: "zxstudent1",
        companyName: "中山大学",
        deptName: "研发一部",
        courseType: "1",
        userId: "10992",
        addTime: "2021-12-01 18:18:28"
      },
      {
        favoritesId: "60",
        courseGoodsName: "mybatis入门到精通（经典版本）",
        courseGoodsId: "135",
        courseImage: "upload/20181119/vvsqy/uwwqz1542609256236.jpg",
        isfree: "0",
        username: "zxstudent1",
        companyName: "中山大学",
        deptName: "研发一部",
        courseType: "1",
        userId: "10992",
        addTime: "2021-10-27 23:07:40"
      },
      {
        favoritesId: "40",
        courseGoodsName: "Spring Security开发安全的REST服务",
        courseGoodsId: "116",
        courseImage: "upload/20181012/svyyy/uqtuv1539312878443.jpg",
        isfree: "1",
        username: "zxstudent1",
        companyName: "中山大学",
        deptName: "研发一部",
        courseType: "1",
        userId: "10992",
        addTime: "2018-12-13 16:47:35"
      },
      {
        favoritesId: "38",
        courseGoodsName: "Spring Security开发安全的REST服务",
        courseGoodsId: "116",
        courseImage: "upload/20181012/svyyy/uqtuv1539312878443.jpg",
        isfree: "1",
        username: "zxstudent22",
        companyName: "中山大学",
        deptName: "研发一部",
        courseType: "1",
        userId: "11013",
        addTime: "2018-11-26 23:00:15"
      },
      {
        favoritesId: "37",
        courseGoodsName: "二十天java从入门到精通",
        courseGoodsId: "95",
        courseImage: "upload/20180821/vyurw/vvxqy1534838251130.jpg",
        isfree: "0",
        username: "zxstudent1",
        companyName: "中山大学",
        deptName: "研发一部",
        courseType: "1",
        userId: "10992",
        addTime: "2018-09-29 14:33:51"
      },
      {
        favoritesId: "36",
        courseGoodsName: "SpringMVC数据绑定入门",
        courseGoodsId: "99",
        courseImage: "upload/20180928/wyzyz/wruvu1538122041536.jpg",
        isfree: "0",
        username: "zxstudent1",
        companyName: "中山大学",
        deptName: "研发一部",
        courseType: "1",
        userId: "10992",
        addTime: "2018-09-28 16:57:41"
      }
    ];
    return list;
  },
  getexaminationsyllabus: function() {
    let list = [
      {
        lessonId: "157",
        lessonName: "酒店企业文化管理",
        lessonDesc:
          "知识经济的到来，把现代企业带入了文化管理时代。在企业文化理论上是“以人为中心”的崭新管理思想，这种以“人”为本，强调关心人、理解人、尊重人、培养人，提倡在满足企业员工物质需要的基础上尽可能地满足人的精神需要的管理思想，是高度重视人的观念和情感因素的非理性管理即文化管理，是知识经济时代企业管理的主要模式。",
        createTime: "2021-07-12 13:55:03"
      },
      {
        lessonId: "147",
        lessonName: "餐饮规范管理",
        lessonDesc:
          "餐饮管理制度是为了加强饭店、食堂、餐厅等服务网点的管理，更好的为人群服务，维护社会的利益而制定。管理制度也有时间性，饭店住所的情况常随时间的不同而变化，管理制度和方法必须因时、因地、因人而变。",
        createTime: "2021-07-21 15:29:21"
      }
      // {
      //   lessonId: "121",
      //   lessonName: "php全栈开发工程师",
      //   lessonDesc:
      //     "PHP作为一种通用开源脚本语言，已入选全球五大最受欢迎的编程语言，是唯一入选的脚本语言。2016年全球5000万互联网网站中，有60%以上使用着PHP技术，国内80%以上的动态网站都在使用PHP开发。2011年PHP从业人数新增42%，PHP程序员和招聘岗位的供求比例是1：40。",
      //   createTime: "2017-11-06 19:18:16"
      // }
    ];
    return list;
  },
  getmyQuestionbank: function() {
    let list = [
      {
        tqId: "2878",
        tqType: "4",
        tqClass: "0",
        lessonId: "147",
        lessonName: "酒店企业文化课程",
        tqResult: "继承、重写、向上转型？",
        userId: "10921",
        tqContext: "java实现多态有三个必要条件?",
        isopen: "0",
        tqDod: "0.5",
        tchapterId: "184",
        truename: "null",
        tqOrder: "null",
        tqStatus: "1",
        tchapterName: "入门"
      },
      {
        tqId: "2877",
        tqType: "5",
        tqClass: "0",
        lessonId: "147",
        lessonName: "酒店企业文化课程",
        tqResult: "3",
        userId: "10921",
        tqContext: "java实现多态有三个必要条件__ 和 __及 __?",
        isopen: "0",
        tqDod: "0.5",
        tchapterId: "null",
        truename: "null",
        tqOrder: "null",
        tqStatus: "1",
        tchapterName: ""
      },
      {
        tqId: "2859",
        tqType: "3",
        tqClass: "1",
        lessonId: "147",
        lessonName: "酒店企业文化课程",
        tqResult: "B",
        userId: "10921",
        tqContext:
          "在制作框架网页时，如果需要保存所有框架网页，则只需要选择文件菜单中的SAVE即...",
        isopen: "1",
        tqDod: "0.3",
        tchapterId: "null",
        truename: "null",
        tqOrder: "null",
        tqStatus: "1",
        tchapterName: ""
      },
      {
        tqId: "2858",
        tqType: "3",
        tqClass: "1",
        lessonId: "147",
        lessonName: "酒店企业文化课程",
        tqResult: "B",
        userId: "10921",
        tqContext: "在Dreamweaver中，非连续的单元格也可直接合并。",
        isopen: "1",
        tqDod: "0.3",
        tchapterId: "null",
        truename: "null",
        tqOrder: "null",
        tqStatus: "1",
        tchapterName: ""
      },
      {
        tqId: "2857",
        tqType: "3",
        tqClass: "1",
        lessonId: "147",
        lessonName: "酒店企业文化课程",
        tqResult: "A",
        userId: "10921",
        tqContext: "在CSS中要设置超链接的样式效果，应指定虚类selector。",
        isopen: "1",
        tqDod: "0.3",
        tchapterId: "null",
        truename: "null",
        tqOrder: "null",
        tqStatus: "1",
        tchapterName: ""
      },
      {
        tqId: "2856",
        tqType: "3",
        tqClass: "1",
        lessonId: "147",
        lessonName: "酒店企业文化课程",
        tqResult: "B",
        userId: "10921",
        tqContext: "一个网页中只能包含一个表单。",
        isopen: "1",
        tqDod: "0.3",
        tchapterId: "null",
        truename: "null",
        tqOrder: "null",
        tqStatus: "1",
        tchapterName: ""
      },
      {
        tqId: "2855",
        tqType: "3",
        tqClass: "1",
        lessonId: "147",
        lessonName: "酒店企业文化课程",
        tqResult: "A",
        userId: "10921",
        tqContext:
          "在HTML表单中，文本框、口令框和复选框都是用INPUT标记符生成的。",
        isopen: "1",
        tqDod: "0.3",
        tchapterId: "null",
        truename: "null",
        tqOrder: "null",
        tqStatus: "1",
        tchapterName: ""
      },
      {
        tqId: "2854",
        tqType: "1",
        tqClass: "1",
        lessonId: "147",
        lessonName: "酒店企业文化课程",
        tqResult: "C",
        userId: "10921",
        tqContext: "关于&lt;table&gt;标记的叙述，错误的是（）。",
        isopen: "1",
        tqDod: "0.3",
        tchapterId: "null",
        truename: "null",
        tqOrder: "null",
        tqStatus: "1",
        tchapterName: ""
      },
      {
        tqId: "2853",
        tqType: "1",
        tqClass: "1",
        lessonId: "147",
        lessonName: "酒店企业文化课程",
        tqResult: "A",
        userId: "10921",
        tqContext: "（）标记标注网页中一个段落的开始。",
        isopen: "1",
        tqDod: "0.3",
        tchapterId: "null",
        truename: "null",
        tqOrder: "null",
        tqStatus: "1",
        tchapterName: ""
      },
      {
        tqId: "2852",
        tqType: "1",
        tqClass: "1",
        lessonId: "147",
        lessonName: "酒店企业文化课程",
        tqResult: "B",
        userId: "10921",
        tqContext: "在Dreamweaver中，单位px表示（）。",
        isopen: "1",
        tqDod: "0.3",
        tchapterId: "null",
        truename: "null",
        tqOrder: "null",
        tqStatus: "1",
        tchapterName: ""
      }
    ];
    return list;
  },
  getSharedquestionbank: function() {
    let list = [
      {
        tqId: "2261",
        tqType: "5",
        tqClass: "1",
        lessonId: "null",
        lessonName: "null",
        tqResult: "null",
        userId: "10920",
        tqContext: "整型常量默认为(        )类型，而123L属于(        )类型。",
        isopen: "1",
        tqDod: "0.1",
        tchapterId: "163",
        truename: "王彦老师",
        tqOrder: "null",
        tqStatus: "null",
        tchapterName: "java基础"
      },
      {
        tqId: "2260",
        tqType: "5",
        tqClass: "1",
        lessonId: "null",
        lessonName: "null",
        tqResult: "null",
        userId: "10920",
        tqContext: "Java中的注释有三种形式：(        )、(       )和单行注释。",
        isopen: "1",
        tqDod: "0.1",
        tchapterId: "163",
        truename: "王彦老师",
        tqOrder: "null",
        tqStatus: "null",
        tchapterName: "java基础"
      },
      {
        tqId: "2259",
        tqType: "5",
        tqClass: "1",
        lessonId: "null",
        lessonName: "null",
        tqResult: "null",
        userId: "10920",
        tqContext:
          "根据柏拉图法则，类先于对象存在。以(        )修饰的数据和方法，被称为...",
        isopen: "1",
        tqDod: "0.1",
        tchapterId: "163",
        truename: "王彦老师",
        tqOrder: "null",
        tqStatus: "null",
        tchapterName: "java基础"
      },
      {
        tqId: "2258",
        tqType: "4",
        tqClass: "1",
        lessonId: "null",
        lessonName: "null",
        tqResult: "null",
        userId: "10920",
        tqContext:
          "”static”关键字是什么意思？Java中是否可以覆盖(override)一...",
        isopen: "1",
        tqDod: "0.3",
        tchapterId: "163",
        truename: "王彦老师",
        tqOrder: "null",
        tqStatus: "null",
        tchapterName: "java基础"
      },
      {
        tqId: "2257",
        tqType: "4",
        tqClass: "1",
        lessonId: "null",
        lessonName: "null",
        tqResult: "null",
        userId: "10920",
        tqContext: "JDK和JRE的区别是什么？",
        isopen: "1",
        tqDod: "0.2",
        tchapterId: "163",
        truename: "王彦老师",
        tqOrder: "null",
        tqStatus: "null",
        tchapterName: "java基础"
      },
      {
        tqId: "2256",
        tqType: "4",
        tqClass: "1",
        lessonId: "null",
        lessonName: "null",
        tqResult: "null",
        userId: "10920",
        tqContext: "什么是Java虚拟机？为什么Java被称作是“平台无关的编程语言”？",
        isopen: "1",
        tqDod: "0.1",
        tchapterId: "163",
        truename: "王彦老师",
        tqOrder: "null",
        tqStatus: "null",
        tchapterName: "java基础"
      },
      {
        tqId: "2255",
        tqType: "3",
        tqClass: "1",
        lessonId: "null",
        lessonName: "null",
        tqResult: "B",
        userId: "10920",
        tqContext: "List，Set，Map是继承自Collection接口（）",
        isopen: "1",
        tqDod: "0.6",
        tchapterId: "163",
        truename: "王彦老师",
        tqOrder: "null",
        tqStatus: "null",
        tchapterName: "java基础"
      },
      {
        tqId: "2254",
        tqType: "3",
        tqClass: "1",
        lessonId: "null",
        lessonName: "null",
        tqResult: "B",
        userId: "10920",
        tqContext: "数组获取长度使用length（）方法",
        isopen: "1",
        tqDod: "0.4",
        tchapterId: "163",
        truename: "王彦老师",
        tqOrder: "null",
        tqStatus: "null",
        tchapterName: "java基础"
      },
      {
        tqId: "2253",
        tqType: "3",
        tqClass: "1",
        lessonId: "null",
        lessonName: "null",
        tqResult: "B",
        userId: "10920",
        tqContext: "String是基本数据类型（）",
        isopen: "1",
        tqDod: "0.3",
        tchapterId: "163",
        truename: "王彦老师",
        tqOrder: "null",
        tqStatus: "null",
        tchapterName: "java基础"
      },
      {
        tqId: "2252",
        tqType: "2",
        tqClass: "1",
        lessonId: "null",
        lessonName: "null",
        tqResult: "AD",
        userId: "10920",
        tqContext: "下面的哪些声明是合法的？（ ）",
        isopen: "1",
        tqDod: "0.2",
        tchapterId: "163",
        truename: "王彦老师",
        tqOrder: "null",
        tqStatus: "null",
        tchapterName: "java基础"
      }
    ];
    return list;
  },
  getmytestpaper: function() {
    let list = [
      {
        spuId: "null",
        pid: "806",
        pname: "酒店企业文化课程练习",
        dabiaolv: "null%",
        psum: "50.0",
        userId: "10921",
        truename: "张三",
        paperStatus: "0",
        statusMsg: "null",
        tqCount: "5",
        companyId: "21",
        companyName: "好记·鼓楼店",
        buyCount: "null",
        freeCount: "null",
        createtime: "2021-01-07 16:10"
      },
      {
        spuId: "null",
        pid: "686",
        pname: "202107餐饮规范考试",
        dabiaolv: "null%",
        psum: "100.0",
        userId: "10921",
        truename: "张三",
        paperStatus: "0",
        statusMsg: "null",
        tqCount: "47",
        companyId: "21",
        companyName: "好记·鼓楼店",
        buyCount: "null",
        freeCount: "null",
        createtime: "2021-05-15 11:35"
      },
      {
        spuId: "null",
        pid: "685",
        pname: "酒店网管试题测试",
        dabiaolv: "null%",
        psum: "30.0",
        userId: "10921",
        truename: "张三",
        paperStatus: "0",
        statusMsg: "null",
        tqCount: "3",
        companyId: "21",
        companyName: "好记·南方时代广场店",
        buyCount: "null",
        freeCount: "null",
        createtime: "2021-01-07 19:23"
      }
    ];
    return list;
  },
  getmyInvigilator: function() {
    let list = [
      {
        examReaduserId: "1085",
        examId: "564",
        examName: "企业文化考试",
        examTime: "2021-01-12 15:54",
        endTime: "2021-01-12 15:54",
        timeLong: "90",
        isreleased: "0",
        userCount: "1",
        examState: "2",
        examStatus: "1",
        pnames: "酒店企业文化课程练习 "
      },
      {
        examReaduserId: "646",
        examId: "376",
        examName: "202107餐饮规范考试",
        examTime: "2021-12-18 16:11",
        endTime: "2021-12-18 16:11",
        timeLong: "90",
        isreleased: "0",
        userCount: "3",
        examState: "0",
        examStatus: "-1",
        pnames: "202107餐饮规范考试"
      },
      {
        examReaduserId: "629",
        examId: "367",
        examName: "酒店网管试题测试",
        examTime: "2021-12-18 16:11",
        endTime: "2021-12-18 16:11",
        timeLong: "90",
        isreleased: "0",
        userCount: "68",
        examState: "2",
        examStatus: "-1",
        pnames: "酒店网管试题测试"
      }
    ];
    return list;
  },
  getMarkingmanagement: function() {
    let list = [
      {
        examId: "693",
        examName: "酒店网管试题测试",
        examTime: "2021-01-07 16:13",
        endTime: "2021-01-07 17:43",
        timeLong: "90",
        iscontrol: "0",
        controlStatus: "null",
        isdisturborder: "1",
        ischangescreen: "1",
        isreleased: "null",
        userCount: "2",
        examStatus: "null",
        joinCount: "2",
        needReadCount: "0",
        readedCount: "0",
        isCreateUser: "false",
        typeCount: "false",
        examDesc:
          "诚实守信是中华民族的优良传统，也是公民的基本道德要求之一。\r\n考试作弊不仅是对自己能力的否定，更是对学校学风的亵渎，\r\n作弊者丢掉的不仅仅是一次考试的成绩，尤其是做人的诚信，\r\n希望广大同学积极备考，迎接本次考试。"
      },
      {
        examId: "692",
        examName: "202107餐饮规范考试",
        examTime: "2021-01-07 16:06",
        endTime: "2021-01-07 17:36",
        timeLong: "90",
        iscontrol: "0",
        controlStatus: "null",
        isdisturborder: "1",
        ischangescreen: "1",
        isreleased: "null",
        userCount: "2",
        examStatus: "null",
        joinCount: "1",
        needReadCount: "0",
        readedCount: "0",
        isCreateUser: "false",
        typeCount: "false",
        examDesc:
          "诚实守信是中华民族的优良传统，也是公民的基本道德要求之一。\r\n考试作弊不仅是对自己能力的否定，更是对学校学风的亵渎，\r\n作弊者丢掉的不仅仅是一次考试的成绩，尤其是做人的诚信，\r\n希望广大同学积极备考，迎接本次考试。"
      },

      {
        examId: "682",
        examName: "企业文化考试",
        examTime: "2021-06-29 14:02",
        endTime: "2021-06-29 15:23",
        timeLong: "990",
        iscontrol: "0",
        controlStatus: "null",
        isdisturborder: "0",
        ischangescreen: "0",
        isreleased: "0",
        userCount: "1",
        examStatus: "null",
        joinCount: "1",
        needReadCount: "1",
        readedCount: "0",
        isCreateUser: "false",
        typeCount: "false",
        examDesc:
          "诚实守信是中华民族的优良传统，也是公民的基本道德要求之一。\r\n考试作弊不仅是对自己能力的否定，更是对学校学风的亵渎，\r\n作弊者丢掉的不仅仅是一次考试的成绩，尤其是做人的诚信，\r\n希望广大同学积极备考，迎接本次考试。"
      }
    ];
    return list;
  },
  getstudyplan: function() {
    let list = [
      {
        planId: "543",
        planName: "一个月学会企业管理",
        planStarttime: "2021-06-01 10:30",
        planEndtime: "2021-06-30 10:31",
        userId: "10921",
        truename: "李老师",
        planStatus: "2",
        buyStudyPlanType: "0",
        planUserCount: "1",
        planDesc: ""
      },
      {
        planId: "533",
        planName: "网管课程一期",
        planStarttime: "2021-03-02 16:45",
        planEndtime: "2021-03-20 16:45",
        userId: "10921",
        truename: "李老师",
        planStatus: "2",
        buyStudyPlanType: "0",
        planUserCount: "3",
        planDesc: ""
      },
      {
        planId: "523",
        planName: "餐饮规范2021一期",
        planStarttime: "2021-03-02 13:57",
        planEndtime: "2021-03-05 12:34",
        userId: "10921",
        truename: "李老师",
        planStatus: "2",
        buyStudyPlanType: "0",
        planUserCount: "2",
        planDesc: ""
      }
    ];
    return list;
  },
  getdesign: function() {
    let list = [
      {
        courseUserId: "1008",
        userId: "10921",
        courseGoodsName: "PHP面向对象编程",
        truename: "gsytest",
        courseImage: "0时50分2秒",
        buyTime: "2021-06-11 00:00",
        lessionNum: "2",
        buyCount: "1",
        freeCount: "0",
        issueId: "11102",
        courseUserType: "0",
        courseTimeLong: "3002",
        dod: "简单",
        specialtyName: "PHP"
      },
      {
        courseUserId: "947",
        userId: "10921",
        courseGoodsName: "微信小程序开发",
        truename: "信息科学技术学院供应商",
        courseImage: "0时17分15秒",
        buyTime: "2021-11-04 00:00",
        lessionNum: "2",
        buyCount: "4",
        freeCount: "2",
        issueId: "11163",
        courseUserType: "0",
        courseTimeLong: "1035",
        dod: "简单",
        specialtyName: "JAVA"
      },
      {
        courseUserId: "877",
        userId: "10921",
        courseGoodsName: "计算机语言概要",
        truename: "邓勇军",
        courseImage: "0时0分0秒",
        buyTime: "2021-07-09 00:00",
        lessionNum: "1",
        buyCount: "1",
        freeCount: "1",
        issueId: "11504",
        courseUserType: "1",
        courseTimeLong: "0",
        dod: "简单",
        specialtyName: "信息与通信工程"
      },
      {
        courseUserId: "797",
        userId: "10921",
        courseGoodsName: "字幕测试课程",
        truename: "李老师",
        courseImage: "0时3分9秒",
        buyTime: "2021-01-06 00:00",
        lessionNum: "1",
        buyCount: "1",
        freeCount: "0",
        issueId: "10921",
        courseUserType: "0",
        courseTimeLong: "189",
        dod: "简单",
        specialtyName: "计算机专业"
      },
      {
        courseUserId: "685",
        userId: "10921",
        courseGoodsName: "路桥员工培训课程",
        truename: "李老师",
        courseImage: "0时0分0秒",
        buyTime: "2018-12-19 09:59",
        lessionNum: "0",
        buyCount: "0",
        freeCount: "0",
        issueId: "10921",
        courseUserType: "2",
        courseTimeLong: "0",
        dod: "简单",
        specialtyName: "信息与通信工程"
      },
      {
        courseUserId: "656",
        userId: "10921",
        courseGoodsName: "php老师发布的导学课程",
        truename: "李老师",
        courseImage: "0时9分49秒",
        buyTime: "2018-11-23 13:16",
        lessionNum: "2",
        buyCount: "0",
        freeCount: "0",
        issueId: "10921",
        courseUserType: "2",
        courseTimeLong: "589",
        dod: "简单",
        specialtyName: "struts"
      },
      {
        courseUserId: "645",
        userId: "10921",
        courseGoodsName: "php老师发布的公开课",
        truename: "李老师",
        courseImage: "0时13分20秒",
        buyTime: "2018-11-23 00:00",
        lessionNum: "1",
        buyCount: "1",
        freeCount: "1",
        issueId: "10921",
        courseUserType: "0",
        courseTimeLong: "800",
        dod: "简单",
        specialtyName: "spring"
      },
      {
        courseUserId: "607",
        userId: "10921",
        courseGoodsName: "mybatis入门到精通（经典版本）",
        truename: "李老师",
        courseImage: "2时24分45秒",
        buyTime: "2018-11-19 00:00",
        lessionNum: "4",
        buyCount: "3",
        freeCount: "0",
        issueId: "10921",
        courseUserType: "2",
        courseTimeLong: "8685",
        dod: "简单",
        specialtyName: "JAVA"
      },
      {
        courseUserId: "515",
        userId: "10921",
        courseGoodsName: "Spring Security开发安全的REST服务",
        truename: "李老师",
        courseImage: "2时51分0秒",
        buyTime: "2018-11-01 00:00",
        lessionNum: "3",
        buyCount: "4",
        freeCount: "0",
        issueId: "10921",
        courseUserType: "0",
        courseTimeLong: "10260",
        dod: "简单",
        specialtyName: "JAVA"
      },
      {
        courseUserId: "345",
        userId: "10921",
        courseGoodsName: "二十天java从入门到精通",
        truename: "李老师",
        courseImage: "2时0分0秒",
        buyTime: "2018-08-21 15:57",
        lessionNum: "3",
        buyCount: "0",
        freeCount: "0",
        issueId: "10921",
        courseUserType: "2",
        courseTimeLong: "7250",
        dod: "一般",
        specialtyName: "JAVA"
      }
    ];
    return list;
  },
  getspeaker: function() {
    let list = [
      {
        pcuId: "306",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "947",
        courseGoodsName: "酒店企业文化课程",
        lessionNum: "2",
        courseTime: "0时17分15秒",
        courseTimeLong: "1035",
        dod: "0",
        specialtyId: "32",
        specialtyName: "JAVA",
        planId: "523",
        planName: "一个月学会企业管理",
        courseUserType: "0",
        planStarttime: "2021-03-02 13:57",
        planEndtime: "2021-03-05 12:34",
        planDesc: "",
        planStatus: "2",
        forumId: "null",
        planCourseType: "1",
        createtime: "2021-11-04 16:31",
        planUserCount: "2"
      },
      {
        pcuId: "276",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "797",
        courseGoodsName: "住宿管理课程",
        lessionNum: "1",
        courseTime: "0时3分9秒",
        courseTimeLong: "189",
        dod: "0",
        specialtyId: "56",
        specialtyName: "计算机专业",
        planId: "494",
        planName: "网管课程一期",
        courseUserType: "0",
        planStarttime: "2021-01-06 16:39",
        planEndtime: "2021-01-06 16:39",
        planDesc: "",
        planStatus: "2",
        forumId: "null",
        planCourseType: "1",
        createtime: "2021-01-06 23:11",
        planUserCount: "1"
      },
      {
        pcuId: "226",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "607",
        courseGoodsName: "餐饮规范管理课程",
        lessionNum: "4",
        courseTime: "2时24分45秒",
        courseTimeLong: "8685",
        dod: "0",
        specialtyId: "32",
        specialtyName: "JAVA",
        planId: "434",
        planName: "餐饮规范2021一期",
        courseUserType: "2",
        planStarttime: "2018-11-19 14:33",
        planEndtime: "2019-04-19 14:33",
        planDesc: "",
        planStatus: "2",
        forumId: "null",
        planCourseType: "1",
        createtime: "2018-11-21 15:52",
        planUserCount: "11"
      }
    ];
    return list;
  },
  getQuestionmanagement: function() {
    let list = [
      {
        problemId: "1325",
        problemContext: "ssssssssss",
        createtime: "2021-07-06 11:40:23",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "656",
        courseGoodsName: "php老师发布的导学课程",
        truename: "Cxy123",
        courseUserVideoId: "2110",
        courseUserVideoTitle: "bhgbgn",
        planId: "464",
        planName: "php老师发布的导学课程"
      },
      {
        problemId: "974",
        problemContext: "很好",
        createtime: "2021-06-23 09:16:29",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "304",
        courseGoodsName: "电子科学与技术导论",
        truename: "Cxy123",
        courseUserVideoId: "1205",
        courseUserVideoTitle: "计算机网络与分类",
        planId: "229",
        planName: "密密麻麻密密"
      },
      {
        problemId: "825",
        problemContext: "34r4r43r",
        createtime: "2021-04-16 10:13:49",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "304",
        courseGoodsName: "电子科学与技术导论",
        truename: "Cxy123",
        courseUserVideoId: "1207",
        courseUserVideoTitle: "常见网络连接设备",
        planId: "227",
        planName: "学习计划"
      },
      {
        problemId: "589",
        problemContext: "swqsq",
        createtime: "2018-10-15 15:25:46",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "304",
        courseGoodsName: "电子科学与技术导论",
        truename: "Cxy123",
        courseUserVideoId: "1206",
        courseUserVideoTitle: "常见网络传输介质",
        planId: "256",
        planName: "电子科学与技术导论"
      },
      {
        problemId: "584",
        problemContext: "很赞喔",
        createtime: "2018-07-09 01:54:25",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "314",
        courseGoodsName:
          "Nginx入门到实践 不管是运维还是开发 Nginx都是你的必备技能",
        truename: "Cxy123",
        courseUserVideoId: "1255",
        courseUserVideoTitle: "nginx介绍及编译安装",
        planId: "201",
        planName: "nginx入门到精通"
      },
      {
        problemId: "572",
        problemContext: "讲的很不错喔",
        createtime: "2018-07-06 13:53:52",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "304",
        courseGoodsName: "电子科学与技术导论",
        truename: "Cxy123",
        courseUserVideoId: "1205",
        courseUserVideoTitle: "计算机网络与分类",
        planId: "191",
        planName: "电子科学与技术导论"
      }
    ];
    return list;
  },
  getQuestionmanagements: function() {
    let list = [
      {
        problemId: "1286",
        problemContext: "111",
        createtime: "2021-06-27 13:36:56",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "1009",
        courseGoodsName: "php老师发布的公开课",
        truename: "Cxy123",
        courseUserVideoId: "2895",
        courseUserVideoTitle: "公开课子章节1",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1167",
        problemContext: "课程包含模块视频，模块文档，模块测试题，模块评论",
        createtime: "2021-01-08 10:54:05",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2820",
        courseUserVideoTitle: "视频文件",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1166",
        problemContext: "课程主题是视频",
        createtime: "2021-01-08 10:53:43",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2820",
        courseUserVideoTitle: "视频文件",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1165",
        problemContext: "测试题不做成在线做嘛",
        createtime: "2021-01-08 10:47:54",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2823",
        courseUserVideoTitle: "doc文档",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1145",
        problemContext: "hhh",
        createtime: "2021-12-16 14:24:44",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2821",
        courseUserVideoTitle: "ppt文档",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1106",
        problemContext: "11111111",
        createtime: "2021-11-21 21:37:20",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2820",
        courseUserVideoTitle: "视频文件",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1105",
        problemContext: "1111",
        createtime: "2021-11-21 21:37:15",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2820",
        courseUserVideoTitle: "视频文件",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1026",
        problemContext: "123",
        createtime: "2021-08-08 15:42:39",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "897",
        courseGoodsName: "字幕测试课程",
        truename: "Cxy123",
        courseUserVideoId: "2745",
        courseUserVideoTitle: "字幕",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1025",
        problemContext: "sdfasdfad",
        createtime: "2021-07-29 09:37:33",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "897",
        courseGoodsName: "字幕测试课程",
        truename: "Cxy123",
        courseUserVideoId: "2746",
        courseUserVideoTitle: "m3u8测试",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "662",
        problemContext: "1",
        createtime: "2018-12-11 17:02:28",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "665",
        courseGoodsName: "Spring Security开发安全的REST服务",
        truename: "Cxy123",
        courseUserVideoId: "2133",
        courseUserVideoTitle: "导学",
        planId: "null",
        planName: "null"
      }
    ];
    return list;
  },
  getStatistics: function() {
    let list = [
      {
        problemId: "1286",
        problemContext: "111",
        createtime: "2021-06-27 13:36:56",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "1009",
        courseGoodsName: "php老师发布的公开课",
        truename: "Cxy123",
        courseUserVideoId: "2895",
        courseUserVideoTitle: "公开课子章节1",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1167",
        problemContext: "课程包含模块视频，模块文档，模块测试题，模块评论",
        createtime: "2021-01-08 10:54:05",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2820",
        courseUserVideoTitle: "视频文件",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1166",
        problemContext: "课程主题是视频",
        createtime: "2021-01-08 10:53:43",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2820",
        courseUserVideoTitle: "视频文件",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1165",
        problemContext: "测试题不做成在线做嘛",
        createtime: "2021-01-08 10:47:54",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2823",
        courseUserVideoTitle: "doc文档",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1145",
        problemContext: "hhh",
        createtime: "2021-12-16 14:24:44",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2821",
        courseUserVideoTitle: "ppt文档",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1106",
        problemContext: "11111111",
        createtime: "2021-11-21 21:37:20",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2820",
        courseUserVideoTitle: "视频文件",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1105",
        problemContext: "1111",
        createtime: "2021-11-21 21:37:15",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "948",
        courseGoodsName: "课程复习与总结",
        truename: "Cxy123",
        courseUserVideoId: "2820",
        courseUserVideoTitle: "视频文件",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1026",
        problemContext: "123",
        createtime: "2021-08-08 15:42:39",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "897",
        courseGoodsName: "字幕测试课程",
        truename: "Cxy123",
        courseUserVideoId: "2745",
        courseUserVideoTitle: "字幕",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "1025",
        problemContext: "sdfasdfad",
        createtime: "2021-07-29 09:37:33",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "897",
        courseGoodsName: "字幕测试课程",
        truename: "Cxy123",
        courseUserVideoId: "2746",
        courseUserVideoTitle: "m3u8测试",
        planId: "null",
        planName: "null"
      },
      {
        problemId: "662",
        problemContext: "1",
        createtime: "2018-12-11 17:02:28",
        problemTitle: "null",
        problemStatus: "0",
        problemtype: "1",
        courseUserId: "665",
        courseGoodsName: "Spring Security开发安全的REST服务",
        truename: "Cxy123",
        courseUserVideoId: "2133",
        courseUserVideoTitle: "导学",
        planId: "null",
        planName: "null"
      }
    ];
    return list;
  },
  getgongkaike: function() {
    let list = [
      {
        courseGoodsId: "158",
        userId: "null",
        courseGoodsName: "课程复习与总结",
        courseImage: "0时11分38秒",
        addtime: "2021-11-06 00:00",
        lessionnum: "1",
        studycount: "0",
        courseSaleCount: "1",
        courseType: "0",
        timelong: "698",
        dod: "null",
        specialtyName: "原生JS"
      },
      {
        courseGoodsId: "143",
        userId: "null",
        courseGoodsName: "字幕测试课程",
        courseImage: "0时6分18秒",
        addtime: "2019-10-17 00:00",
        lessionnum: "1",
        studycount: "0",
        courseSaleCount: "4",
        courseType: "0",
        timelong: "378",
        dod: "null",
        specialtyName: "计算机专业"
      },
      {
        courseGoodsId: "137",
        userId: "null",
        courseGoodsName: "php老师发布的公开课",
        courseImage: "0时13分20秒",
        addtime: "2018-11-23 00:00",
        lessionnum: "1",
        studycount: "0",
        courseSaleCount: "3",
        courseType: "0",
        timelong: "800",
        dod: "null",
        specialtyName: "spring"
      },
      {
        courseGoodsId: "116",
        userId: "null",
        courseGoodsName: "Spring Security开发安全的REST服务",
        courseImage: "2时3分21秒",
        addtime: "2018-10-12 00:00",
        lessionnum: "4",
        studycount: "0",
        courseSaleCount: "17",
        courseType: "0",
        timelong: "7401",
        dod: "null",
        specialtyName: "JAVA"
      },
      {
        courseGoodsId: "99",
        userId: "null",
        courseGoodsName: "SpringMVC数据绑定入门",
        courseImage: "0时0分0秒",
        addtime: "2018-09-28 00:00",
        lessionnum: "4",
        studycount: "0",
        courseSaleCount: "1",
        courseType: "0",
        timelong: "0",
        dod: "null",
        specialtyName: "JAVA"
      },
      {
        courseGoodsId: "98",
        userId: "null",
        courseGoodsName: "springcloud新特性",
        courseImage: "0时26分40秒",
        addtime: "2018-09-28 00:00",
        lessionnum: "2",
        studycount: "0",
        courseSaleCount: "1",
        courseType: "0",
        timelong: "1600",
        dod: "null",
        specialtyName: "JAVA"
      }
    ];
    return list;
  },
  getcircle: function() {
    let list = [
      {
        pcuId: "13",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "110",
        courseGoodsName: "dasd",
        lessionNum: "2",
        courseTime: "0时0分0秒",
        courseTimeLong: "0",
        dod: "0",
        specialtyId: "29",
        specialtyName: "HTML4.0",
        planId: "70",
        planName: "2017年下学期java学习计划",
        courseUserType: "null",
        planStarttime: "2017-09-01 17:08",
        planEndtime: "2017-09-30 17:08",
        planDesc: "",
        planStatus: "null",
        forumId: "21",
        planCourseType: "1",
        createtime: "2017-09-01 17:17",
        planUserCount: "67"
      },
      {
        pcuId: "306",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "947",
        courseGoodsName: "微信小程序开发",
        lessionNum: "2",
        courseTime: "0时17分15秒",
        courseTimeLong: "1035",
        dod: "0",
        specialtyId: "32",
        specialtyName: "JAVA",
        planId: "523",
        planName: "微信小程序开发-购买供应商的公开课",
        courseUserType: "null",
        planStarttime: "2021-03-02 13:57",
        planEndtime: "2021-03-05 12:34",
        planDesc: "",
        planStatus: "null",
        forumId: "null",
        planCourseType: "1",
        createtime: "2021-11-04 16:31",
        planUserCount: "2"
      },
      {
        pcuId: "226",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "607",
        courseGoodsName: "mybatis入门到精通（经典版本）",
        lessionNum: "4",
        courseTime: "2时24分45秒",
        courseTimeLong: "8685",
        dod: "0",
        specialtyId: "32",
        specialtyName: "JAVA",
        planId: "434",
        planName: "mybatis入门到精通（经典版本）-导学课",
        courseUserType: "null",
        planStarttime: "2018-11-19 14:33",
        planEndtime: "2019-04-19 14:33",
        planDesc: "",
        planStatus: "null",
        forumId: "null",
        planCourseType: "1",
        createtime: "2018-11-21 15:52",
        planUserCount: "11"
      },
      {
        pcuId: "156",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "345",
        courseGoodsName: "二十天java从入门到精通",
        lessionNum: "3",
        courseTime: "2时0分0秒",
        courseTimeLong: "7250",
        dod: "1",
        specialtyId: "32",
        specialtyName: "JAVA",
        planId: "243",
        planName: "mybatis入门到精通",
        courseUserType: "null",
        planStarttime: "2018-09-11 12:56",
        planEndtime: "2019-11-22 14:56",
        planDesc: "",
        planStatus: "null",
        forumId: "122",
        planCourseType: "1",
        createtime: "2018-08-21 16:10",
        planUserCount: "5"
      },
      {
        pcuId: "188",
        managerType: "2",
        pcuDesc: "",
        courseUserId: "556",
        courseGoodsName: "ssh框架整合课程",
        lessionNum: "0",
        courseTime: "0时0分0秒",
        courseTimeLong: "0",
        dod: "0",
        specialtyId: "32",
        specialtyName: "JAVA",
        planId: "354",
        planName: "ssh框架整合课程-向导课程",
        courseUserType: "null",
        planStarttime: "2018-11-06 13:42",
        planEndtime: "2018-12-06 13:42",
        planDesc: "",
        planStatus: "null",
        forumId: "162",
        planCourseType: "null",
        createtime: "2018-11-06 16:12",
        planUserCount: "1"
      },
      {
        pcuId: "276",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "797",
        courseGoodsName: "字幕测试课程",
        lessionNum: "1",
        courseTime: "0时3分9秒",
        courseTimeLong: "189",
        dod: "0",
        specialtyId: "56",
        specialtyName: "计算机专业",
        planId: "494",
        planName: "字幕测试课程",
        courseUserType: "null",
        planStarttime: "2021-01-06 16:39",
        planEndtime: "2021-01-06 16:39",
        planDesc: "",
        planStatus: "null",
        forumId: "null",
        planCourseType: "1",
        createtime: "2021-01-06 23:11",
        planUserCount: "1"
      },
      {
        pcuId: "177",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "304",
        courseGoodsName: "电子科学与技术导论",
        lessionNum: "11",
        courseTime: "4时27分39秒",
        courseTimeLong: "16059",
        dod: "0",
        specialtyId: "46",
        specialtyName: "电子科学与技术",
        planId: "263",
        planName: "2018年9月17日开学课程",
        courseUserType: "null",
        planStarttime: "2018-09-17 16:48",
        planEndtime: "2019-01-17 16:48",
        planDesc: "",
        planStatus: "null",
        forumId: "142",
        planCourseType: "1",
        createtime: "2018-09-17 16:49",
        planUserCount: "2"
      },
      {
        pcuId: "246",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "304",
        courseGoodsName: "电子科学与技术导论",
        lessionNum: "11",
        courseTime: "4时27分39秒",
        courseTimeLong: "16059",
        dod: "0",
        specialtyId: "46",
        specialtyName: "电子科学与技术",
        planId: "413",
        planName: "电子科学与技术导论-2018-11-15",
        courseUserType: "null",
        planStarttime: "2019-09-29 10:55",
        planEndtime: "2019-10-22 12:00",
        planDesc: "",
        planStatus: "null",
        forumId: "null",
        planCourseType: "1",
        createtime: "2019-07-25 11:21",
        planUserCount: "3"
      },
      {
        pcuId: "256",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "304",
        courseGoodsName: "电子科学与技术导论",
        lessionNum: "11",
        courseTime: "4时27分39秒",
        courseTimeLong: "16059",
        dod: "0",
        specialtyId: "46",
        specialtyName: "电子科学与技术",
        planId: "191",
        planName: "电子科学与技术导论",
        courseUserType: "null",
        planStarttime: "2019-09-27 10:06",
        planEndtime: "2019-11-22 12:00",
        planDesc: "",
        planStatus: "null",
        forumId: "null",
        planCourseType: "2",
        createtime: "2019-09-27 10:07",
        planUserCount: "1"
      },
      {
        pcuId: "107",
        managerType: "1",
        pcuDesc: "",
        courseUserId: "304",
        courseGoodsName: "电子科学与技术导论",
        lessionNum: "11",
        courseTime: "4时27分39秒",
        courseTimeLong: "16059",
        dod: "0",
        specialtyId: "46",
        specialtyName: "电子科学与技术",
        planId: "202",
        planName: "供应商测验（老师引用）",
        courseUserType: "null",
        planStarttime: "2018-08-10 12:24",
        planEndtime: "2018-10-10 12:24",
        planDesc: "",
        planStatus: "null",
        forumId: "102",
        planCourseType: "1",
        createtime: "2018-08-10 12:29",
        planUserCount: "1"
      }
    ];
    return list;
  },
  getreport: function() {
    let list = [];
    return list;
  },
  getquestionnaireinvestigation: function() {
    let list = [
      {
        paperid: "142",
        title: "springboot给你们企业带来了哪些优势？",
        people: "研发二部,研发一部,",
        thanksmsg: "null",
        selectiontype: "0",
        starttime: "2018-11-16 14:54:56",
        endtime: "2019-02-16 14:54:58"
      }
    ];
    return list;
  },
  getstudents: function() {
    let list = [
      {
        userId: "11142",
        username: "jdbstudent1",
        truename: "jdbstudent1",
        usersex: "2",
        mobilephone: "null",
        deptId: "67",
        deptName: "研发二部",
        deptFullName: "研发二部",
        studentId: "201711222"
      },
      {
        userId: "11059",
        username: "zxstudent68",
        truename: "中芯学院68",
        usersex: "1",
        mobilephone: "null",
        deptId: "67",
        deptName: "研发二部",
        deptFullName: "研发二部",
        studentId: "zxstudent68"
      },
      {
        userId: "11058",
        username: "zxstudent67",
        truename: "中芯学院67",
        usersex: "1",
        mobilephone: "null",
        deptId: "67",
        deptName: "研发二部",
        deptFullName: "研发二部",
        studentId: "zxstudent67"
      },
      {
        userId: "11057",
        username: "zxstudent66",
        truename: "中芯学院66",
        usersex: "1",
        mobilephone: "null",
        deptId: "67",
        deptName: "研发二部",
        deptFullName: "研发二部",
        studentId: "zxstudent66"
      },
      {
        userId: "11056",
        username: "zxstudent65",
        truename: "中芯学院65",
        usersex: "1",
        mobilephone: "null",
        deptId: "67",
        deptName: "研发二部",
        deptFullName: "研发二部",
        studentId: "zxstudent65"
      },
      {
        userId: "11055",
        username: "zxstudent64",
        truename: "中芯学院64",
        usersex: "1",
        mobilephone: "null",
        deptId: "67",
        deptName: "研发二部",
        deptFullName: "研发二部",
        studentId: "zxstudent64"
      },
      {
        userId: "11054",
        username: "zxstudent63",
        truename: "中芯学院63",
        usersex: "1",
        mobilephone: "null",
        deptId: "67",
        deptName: "研发二部",
        deptFullName: "研发二部",
        studentId: "zxstudent63"
      },
      {
        userId: "11053",
        username: "zxstudent62",
        truename: "中芯学院62",
        usersex: "1",
        mobilephone: "null",
        deptId: "67",
        deptName: "研发二部",
        deptFullName: "研发二部",
        studentId: "zxstudent62"
      },
      {
        userId: "11052",
        username: "zxstudent61",
        truename: "中芯学院61",
        usersex: "1",
        mobilephone: "null",
        deptId: "67",
        deptName: "研发二部",
        deptFullName: "研发二部",
        studentId: "zxstudent61"
      },
      {
        userId: "11051",
        username: "zxstudent60",
        truename: "中芯学院60",
        usersex: "1",
        mobilephone: "null",
        deptId: "67",
        deptName: "研发二部",
        deptFullName: "研发二部",
        studentId: "zxstudent60"
      }
    ];
    return list;
  },
  getexamination: function() {
    let list = [
      {
        examId: "693",
        examName: "酒店网管试题测试",
        examTime: "2021-01-07 16:13",
        endTime: "2021-01-07 17:43",
        timeLong: "90",
        iscontrol: "0",
        controlStatus: "null",
        isdisturborder: "1",
        ischangescreen: "1",
        isreleased: "null",
        userCount: "2",
        examStatus: "-1",
        joinCount: "null",
        needReadCount: "null",
        readedCount: "null",
        isCreateUser: "true",
        typeCount: "false",
        examDesc:
          "诚实守信是中华民族的优良传统，也是公民的基本道德要求之一。\r\n考试作弊不仅是对自己能力的否定，更是对学校学风的亵渎，\r\n作弊者丢掉的不仅仅是一次考试的成绩，尤其是做人的诚信，\r\n希望广大同学积极备考，迎接本次考试。",
        pnames: "酒店网管试题测试"
      },
      {
        examId: "692",
        examName: "202107餐饮规范考试",
        examTime: "2021-01-07 16:06",
        endTime: "2021-01-07 17:36",
        timeLong: "90",
        iscontrol: "0",
        controlStatus: "null",
        isdisturborder: "1",
        ischangescreen: "1",
        isreleased: "null",
        userCount: "2",
        examStatus: "-1",
        joinCount: "null",
        needReadCount: "null",
        readedCount: "null",
        isCreateUser: "true",
        typeCount: "false",
        examDesc:
          "诚实守信是中华民族的优良传统，也是公民的基本道德要求之一。\r\n考试作弊不仅是对自己能力的否定，更是对学校学风的亵渎，\r\n作弊者丢掉的不仅仅是一次考试的成绩，尤其是做人的诚信，\r\n希望广大同学积极备考，迎接本次考试。",
        pnames: "202107餐饮规范考试"
      },
      {
        examId: "691",
        examName: "企业文化考试",
        examTime: "2021-01-07 15:45",
        endTime: "2021-01-08 17:09",
        timeLong: "90",
        iscontrol: "0",
        controlStatus: "null",
        isdisturborder: "1",
        ischangescreen: "0",
        isreleased: "0",
        userCount: "1",
        examStatus: "-1",
        joinCount: "null",
        needReadCount: "null",
        readedCount: "null",
        isCreateUser: "true",
        typeCount: "false",
        examDesc:
          "诚实守信是中华民族的优良传统，也是公民的基本道德要求之一。\r\n考试作弊不仅是对自己能力的否定，更是对学校学风的亵渎，\r\n作弊者丢掉的不仅仅是一次考试的成绩，尤其是做人的诚信，\r\n希望广大同学积极备考，迎接本次考试。",
        pnames: "酒店企业文化课程练习"
      }
    ];
    return list;
  },
  gettestreport: function() {
    let list = [
      {
        studyTestId: "726",
        studyTestName: "小程序章节测验（二）",
        studyTestCreateTime: "2021-03-02 14:02",
        studyTestStartTime: "2021-03-02 14:06",
        studyTestEndTime: "2021-03-03 15:34",
        studyTestTimeLong: "180",
        studyTestUserCount: "2",
        studyTestIscontrol: "0",
        studyTestControlStatus: "0",
        studyTestIsdisturborder: "0",
        studyTestIschangescreen: "0",
        studyTestIsreleased: "0",
        studyTestResultCount: "null",
        typeCount: "false",
        joinCount: "1",
        submitCount: "0",
        needReadCount: "0",
        readedCount: "0",
        planName: "微信小程序开发-购买供应商的公开课",
        planId: "523"
      },
      {
        studyTestId: "745",
        studyTestName: "测试测验",
        studyTestCreateTime: "2021-01-07 16:28",
        studyTestStartTime: "2021-03-02 14:03",
        studyTestEndTime: "2021-03-02 15:34",
        studyTestTimeLong: "90",
        studyTestUserCount: "2",
        studyTestIscontrol: "1",
        studyTestControlStatus: "1",
        studyTestIsdisturborder: "1",
        studyTestIschangescreen: "0",
        studyTestIsreleased: "0",
        studyTestResultCount: "null",
        typeCount: "false",
        joinCount: "1",
        submitCount: "0",
        needReadCount: "0",
        readedCount: "0",
        planName: "微信小程序开发-购买供应商的公开课",
        planId: "523"
      },
      {
        studyTestId: "725",
        studyTestName: "小程序章节测验（一）",
        studyTestCreateTime: "2021-11-04 16:31",
        studyTestStartTime: "2021-03-02 14:07",
        studyTestEndTime: "2021-03-03 15:34",
        studyTestTimeLong: "90",
        studyTestUserCount: "2",
        studyTestIscontrol: "0",
        studyTestControlStatus: "0",
        studyTestIsdisturborder: "0",
        studyTestIschangescreen: "0",
        studyTestIsreleased: "0",
        studyTestResultCount: "null",
        typeCount: "false",
        joinCount: "1",
        submitCount: "0",
        needReadCount: "0",
        readedCount: "0",
        planName: "微信小程序开发-购买供应商的公开课",
        planId: "523"
      },
      {
        studyTestId: "665",
        studyTestName: "20210515测验（A卷）",
        studyTestCreateTime: "2021-05-15 15:23",
        studyTestStartTime: "2021-03-01 10:59",
        studyTestEndTime: "2021-03-05 10:58",
        studyTestTimeLong: "90",
        studyTestUserCount: "1",
        studyTestIscontrol: "0",
        studyTestControlStatus: "1",
        studyTestIsdisturborder: "0",
        studyTestIschangescreen: "0",
        studyTestIsreleased: "1",
        studyTestResultCount: "null",
        typeCount: "false",
        joinCount: "1",
        submitCount: "0",
        needReadCount: "1",
        readedCount: "1",
        planName: "学习计划",
        planId: "227"
      },
      {
        studyTestId: "645",
        studyTestName: "父章节测验",
        studyTestCreateTime: "2021-01-06 21:40",
        studyTestStartTime: "2021-01-06 21:40",
        studyTestEndTime: "2021-01-06 23:10",
        studyTestTimeLong: "90",
        studyTestUserCount: "11",
        studyTestIscontrol: "0",
        studyTestControlStatus: "0",
        studyTestIsdisturborder: "0",
        studyTestIschangescreen: "0",
        studyTestIsreleased: "0",
        studyTestResultCount: "null",
        typeCount: "false",
        joinCount: "0",
        submitCount: "0",
        needReadCount: "0",
        readedCount: "0",
        planName: "mybatis入门到精通（经典版本）-导学课",
        planId: "434"
      },
      {
        studyTestId: "625",
        studyTestName: "app综合测验测试",
        studyTestCreateTime: "2019-12-06 17:23",
        studyTestStartTime: "2021-01-02 13:58",
        studyTestEndTime: "2021-01-23 12:34",
        studyTestTimeLong: "1000",
        studyTestUserCount: "11",
        studyTestIscontrol: "0",
        studyTestControlStatus: "0",
        studyTestIsdisturborder: "0",
        studyTestIschangescreen: "0",
        studyTestIsreleased: "0",
        studyTestResultCount: "null",
        typeCount: "false",
        joinCount: "1",
        submitCount: "1",
        needReadCount: "1",
        readedCount: "1",
        planName: "mybatis入门到精通（经典版本）-导学课",
        planId: "434"
      },
      {
        studyTestId: "605",
        studyTestName: "章节测验-201912",
        studyTestCreateTime: "2019-12-05 10:57",
        studyTestStartTime: "2019-12-05 10:57",
        studyTestEndTime: "2019-12-05 12:27",
        studyTestTimeLong: "90",
        studyTestUserCount: "11",
        studyTestIscontrol: "0",
        studyTestControlStatus: "0",
        studyTestIsdisturborder: "0",
        studyTestIschangescreen: "0",
        studyTestIsreleased: "1",
        studyTestResultCount: "null",
        typeCount: "false",
        joinCount: "1",
        submitCount: "1",
        needReadCount: "1",
        readedCount: "1",
        planName: "mybatis入门到精通（经典版本）-导学课",
        planId: "434"
      },
      {
        studyTestId: "566",
        studyTestName: "mybatis高级映射测验",
        studyTestCreateTime: "2019-10-28 18:34",
        studyTestStartTime: "2019-10-28 18:33",
        studyTestEndTime: "2019-10-28 20:03",
        studyTestTimeLong: "90",
        studyTestUserCount: "11",
        studyTestIscontrol: "0",
        studyTestControlStatus: "0",
        studyTestIsdisturborder: "0",
        studyTestIschangescreen: "0",
        studyTestIsreleased: "1",
        studyTestResultCount: "null",
        typeCount: "false",
        joinCount: "1",
        submitCount: "1",
        needReadCount: "1",
        readedCount: "1",
        planName: "mybatis入门到精通（经典版本）-导学课",
        planId: "434"
      },
      {
        studyTestId: "565",
        studyTestName: "mybatis章节resultType测验",
        studyTestCreateTime: "2019-10-28 18:23",
        studyTestStartTime: "2019-10-28 18:22",
        studyTestEndTime: "2019-10-28 20:52",
        studyTestTimeLong: "90",
        studyTestUserCount: "11",
        studyTestIscontrol: "0",
        studyTestControlStatus: "0",
        studyTestIsdisturborder: "0",
        studyTestIschangescreen: "0",
        studyTestIsreleased: "1",
        studyTestResultCount: "null",
        typeCount: "false",
        joinCount: "1",
        submitCount: "1",
        needReadCount: "0",
        readedCount: "0",
        planName: "mybatis入门到精通（经典版本）-导学课",
        planId: "434"
      },
      {
        studyTestId: "465",
        studyTestName: "java基础测验",
        studyTestCreateTime: "2019-08-16 15:08",
        studyTestStartTime: "2019-08-16 15:08",
        studyTestEndTime: "2021-06-16 16:38",
        studyTestTimeLong: "90",
        studyTestUserCount: "1",
        studyTestIscontrol: "0",
        studyTestControlStatus: "1",
        studyTestIsdisturborder: "0",
        studyTestIschangescreen: "0",
        studyTestIsreleased: "0",
        studyTestResultCount: "null",
        typeCount: "false",
        joinCount: "1",
        submitCount: "1",
        needReadCount: "0",
        readedCount: "0",
        planName: "学习计划",
        planId: "227"
      }
    ];
    return list;
  },
  getcoursereport: function() {
    let list = [
      {
        courseGoodsId: "158",
        courseGoodsName: "课程复习与总结",
        courseDesc: "课程复习与总结",
        courseStatus: "1",
        dod: "0",
        isfree: "0",
        assistStatus: "null",
        salesStatus: "null",
        lessionnum: "1",
        courseImage: "0时11分38秒",
        timelong: "698",
        courseType: "0",
        isopen: "1",
        starLevel: "暂无评分",
        studycount: "0",
        addtime: "2021-11-06 00:00:00"
      },
      {
        courseGoodsId: "143",
        courseGoodsName: "字幕测试课程",
        courseDesc: "字幕测试课程字幕测试课程",
        courseStatus: "1",
        dod: "0",
        isfree: "1",
        assistStatus: "null",
        salesStatus: "null",
        lessionnum: "1",
        courseImage: "0时6分18秒",
        timelong: "378",
        courseType: "0",
        isopen: "1",
        starLevel: "非常好",
        studycount: "1",
        addtime: "2019-10-17 00:00:00"
      },
      {
        courseGoodsId: "141",
        courseGoodsName: "路桥员工培训课程",
        courseDesc:
          "路桥员工培训课程路桥员工培训课程路桥员工培训课程路桥员工培训课程",
        courseStatus: "4",
        dod: "0",
        isfree: "0",
        assistStatus: "0",
        salesStatus: "null",
        lessionnum: "0",
        courseImage: "0时0分0秒",
        timelong: "0",
        courseType: "2",
        isopen: "1",
        starLevel: "暂无评分",
        studycount: "1",
        addtime: "2018-12-19 00:00:00"
      },
      {
        courseGoodsId: "137",
        courseGoodsName: "php老师发布的公开课",
        courseDesc: "php老师发布的公开课",
        courseStatus: "4",
        dod: "0",
        isfree: "0",
        assistStatus: "1",
        salesStatus: "1",
        lessionnum: "1",
        courseImage: "0时13分20秒",
        timelong: "800",
        courseType: "0",
        isopen: "1",
        starLevel: "暂无评分",
        studycount: "0",
        addtime: "2018-11-23 00:00:00"
      },
      {
        courseGoodsId: "139",
        courseGoodsName: "php老师发布的导学课程",
        courseDesc: "php老师发布的导学课程",
        courseStatus: "4",
        dod: "0",
        isfree: "0",
        assistStatus: "1",
        salesStatus: "null",
        lessionnum: "1",
        courseImage: "0时9分49秒",
        timelong: "589",
        courseType: "2",
        isopen: "1",
        starLevel: "暂无评分",
        studycount: "1",
        addtime: "2018-11-23 00:00:00"
      },
      {
        courseGoodsId: "135",
        courseGoodsName: "mybatis入门到精通（经典版本）",
        courseDesc:
          "MyBatis 本是apache的一个开源项目iBatis, 2010年这个项目由apache software foundation 迁移到了google code，并且改名为MyBatis，2013年11月迁移到Github。iBATIS一词来源于“internet”和“abatis”的组合，是一个基于Java的持久层框架",
        courseStatus: "1",
        dod: "0",
        isfree: "0",
        assistStatus: "1",
        salesStatus: "null",
        lessionnum: "4",
        courseImage: "2时24分45秒",
        timelong: "8685",
        courseType: "2",
        isopen: "0",
        starLevel: "暂无评分",
        studycount: "11",
        addtime: "2018-11-19 00:00:00"
      },
      {
        courseGoodsId: "116",
        courseGoodsName: "Spring Security开发安全的REST服务",
        courseDesc:
          "不仅能学到spring security技术栈的知识，还能学习到老师教授的很多编程思想，受益匪浅。期待老师的后续课程。 讲师回复 感谢支持，祝学习愉快",
        courseStatus: "1",
        dod: "0",
        isfree: "1",
        assistStatus: "1",
        salesStatus: "1",
        lessionnum: "4",
        courseImage: "2时3分21秒",
        timelong: "7401",
        courseType: "0",
        isopen: "0",
        starLevel: "非常好",
        studycount: "1",
        addtime: "2018-10-12 00:00:00"
      },
      {
        courseGoodsId: "99",
        courseGoodsName: "SpringMVC数据绑定入门",
        courseDesc:
          "学习本门课程前需要具备SpringMVC的基础知识，可以观看慕课网的《Spring MVC起步》课程；同时小伙伴们需要对Servlet相关知识要有一定掌握；本课程选用SpringMVC4.0版本",
        courseStatus: "4",
        dod: "0",
        isfree: "0",
        assistStatus: "1",
        salesStatus: "null",
        lessionnum: "4",
        courseImage: "0时0分0秒",
        timelong: "0",
        courseType: "0",
        isopen: "0",
        starLevel: "暂无评分",
        studycount: "0",
        addtime: "2018-09-28 00:00:00"
      },
      {
        courseGoodsId: "98",
        courseGoodsName: "springcloud新特性",
        courseDesc:
          "pring Cloud是一个基于Spring Boot实现的云应用开发工具，它为基于JVM的云应用开发中的配置管理、服务发现、断路器、智能路由、微代理、控制总线、全局锁、决策竞选、分布式会话和集群状态管理等操作提供了一种简单的开发方式",
        courseStatus: "4",
        dod: "0",
        isfree: "0",
        assistStatus: "1",
        salesStatus: "null",
        lessionnum: "2",
        courseImage: "0时26分40秒",
        timelong: "1600",
        courseType: "0",
        isopen: "1",
        starLevel: "暂无评分",
        studycount: "0",
        addtime: "2018-09-28 00:00:00"
      },
      {
        courseGoodsId: "95",
        courseGoodsName: "二十天java从入门到精通",
        courseDesc:
          "Java是一种可以撰写跨平台应用软件的面向对象的程序设计语言，自面世后就非常流行，发展迅速，对C++语言形成了有力冲击。Java 技术具有卓越的通用性、高效性、平台移植性和安全性，广泛应用于互联网技术中。在全球云计算和移动互联网的产业环境下，Java更具备了显著优势和广阔前景。",
        courseStatus: "4",
        dod: "1",
        isfree: "0",
        assistStatus: "1",
        salesStatus: "1",
        lessionnum: "2",
        courseImage: "0时53分24秒",
        timelong: "3204",
        courseType: "2",
        isopen: "0",
        starLevel: "暂无评分",
        studycount: "5",
        addtime: "2018-08-21 00:00:00"
      }
    ];
    return list;
  },
  getechartsone: function() {
    let list = {
      datas: [1, 3, 4],
      isSuccess: 1,
      lessonName: "php全栈开发工程师",
      options: ["填空题", "实践操作题", "一般"]
    };
    return list;
  },
  getechartstwo: function() {
    let list = {
      datas: [1, 1],
      isSuccess: 1,
      lessonName: "Spring Boot基础",
      options: ["单选题", "一般"]
    };
    return list;
  },
  getechartsthree: function() {
    let list = {
      datas: [27, 1, 7, 4, 4, 4, 7, 1, 30, 25],
      isSuccess: 1,
      lessonName: "java基础",
      options: [
        "单选题",
        "阅读理解题",
        "多选题",
        "问答题",
        "填空题",
        "实践操作题",
        "判断题",
        "论述题",
        "较难",
        "一般"
      ]
    };
    return list;
  }
};



//////////////////
// WEBPACK FOOTER
// ./common_function/commonData.js
// module id = null
// module chunks = 